import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CarrierScorecardEntry, RejectedLoads, ShiftSchedulingStats } from '../../../types';
import { sortBy } from '../../../utilities/commonSorters';
import { loadSorting, saveSorting } from '../../../utilities/sortingSave';
import { CompanyService } from '../../company.service';
import { DriversService } from '../../drivers.service';

type CSESorter = (a: CarrierScorecardEntry, b: CarrierScorecardEntry) => number;

@Component({
  selector: 'lohi-carrier-scorecard',
  templateUrl: './carrier-scorecard.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarrierScorecardComponent implements OnInit {
  public carriers$: Observable<CarrierScorecardEntry[]>;
  public sortBy: keyof CarrierScorecardEntry = 'prescheduledShiftsPercent';
  public sortReverse = true;
  public sortingFunction$$ = new BehaviorSubject<CSESorter>(getSortBy(this.sortBy, this.sortReverse));

  public driversRejected$: Observable<RejectedLoads>;
  public scheduling$: Observable<ShiftSchedulingStats>;

  constructor(private companyService: CompanyService, private driversService: DriversService) {}

  public ngOnInit(): void {
    this.driversRejected$ = this.driversService.driverStatsLoads$;
    this.scheduling$ = this.driversService.shiftStatsDrivers$;
    const sortingData = loadSorting('cscorecard');
    if (sortingData) {
      this.sortBy = sortingData.sortBy;
      this.sortReverse = sortingData.sortDirection;
      this.sortingFunction$$.next(getSortBy(this.sortBy, this.sortReverse));
    }

    this.carriers$ = combineLatest([this.companyService.companyScorecard$, this.sortingFunction$$]).pipe(
      filter(([drivers]) => !!drivers),
      map(([value, sortFunc]) => value.sort(sortFunc)),
    );
  }

  public setSortHeader(key: keyof CarrierScorecardEntry) {
    if (key === this.sortBy) {
      this.sortReverse = !this.sortReverse;
    } else {
      this.sortBy = key;
      this.sortReverse = false;
    }
    saveSorting('cscorecard', this.sortBy, this.sortReverse);
    this.sortingFunction$$.next(getSortBy(this.sortBy, this.sortReverse));
  }
}

function getSortBy(key: keyof CarrierScorecardEntry, reverse: boolean): CSESorter {
  const temp = sortBy(`${reverse ? '-' : ''}${key}`);
  return (a: CarrierScorecardEntry, b: CarrierScorecardEntry) => {
    return temp(a, b);
  };
}
